module.exports = __webpack_public_path__ + "img/read.a905ee83.svg";